import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-upload-documents-delete-dialogs',
  templateUrl: './upload-documents-delete-dialogs.component.html',
  styleUrls: ['./upload-documents-delete-dialogs.component.scss']
})

export class UploadDocumentsDeleteDialogsComponent implements OnInit {
  documentsName: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { documentName : any },
    private dialogRef: MatDialogRef<UploadDocumentsDeleteDialogsComponent>,
  ) { }

  ngOnInit(): void {
    this.documentsName = this.data.documentName;
  }
  onYesClick() {
    this.dialogRef.close(true) ;
  }
  onCloseClick() {
    this.dialogRef.close(null);
  }

}
